import { useMemo } from 'react';

import { useApp } from '@hooks/use-app';

import { RouteModel, paiementRoute } from '@helpers/routes';

export function useShouldShowOptionStep(stepRoute: RouteModel | undefined): boolean | null {
    const { hasOptionsAvailable } = useApp();

    return useMemo(() => {
        if (typeof window === 'undefined') return null;

        let hasOptions = hasOptionsAvailable;
        if (hasOptions === null) {
            const stored = localStorage.getItem('hasOptionsAvailable');
            if (stored !== null) {
                hasOptions = stored === 'true';
            }
        }

        if (hasOptions) {
            return true;
        }

        if (hasOptions === false) {
            return false;
        }

        const isCurrentStepBeyondOptions = stepRoute && stepRoute.step > paiementRoute.step;

        if (isCurrentStepBeyondOptions) {
            return false;
        }

        return null;
    }, [hasOptionsAvailable, stepRoute]);
}
